<template>
  <div class="full">
    <GamePlay class="full"></GamePlay>
  </div>
</template>

<script>
export default {
  components: {
    GamePlay: () => import('../game/CellGame.vue')
  }
}
</script>

<style scoped>
.full{
  width: 100%;
  height: 100%;
}
</style>
